import LogRocket from 'logrocket';
import { configureStore } from '@reduxjs/toolkit';
import { routerMiddleware } from 'connected-react-router';
import { setupListeners } from '@reduxjs/toolkit/query/react';

import { createReducerInjecter } from '@surfline/web-common';
import rootReducer from '../reducers';
import { surfCheckMeteringMiddleware, apiMiddlewares } from './middlewares';
import createReducer from '../reducers/createReducer';

/**
 * @typedef {ReturnType<ReturnType<typeof rootReducer>>} RootState
 */

/**
 * @typedef {import("@surfline/web-common").injectReducer} injectReducer
 */

/**
 * @typedef {import("@surfline/web-common").AsyncReducers} AsyncReducers
 */

function createStore(preloadedState, history) {
  const extraReducers = {
    backplane: createReducer({}, null),
  };

  /** @type {import('@reduxjs/toolkit').EnhancedStore & {injectReducer: injectReducer, asyncReducers: AsyncReducers}} */
  const store = configureStore({
    preloadedState,
    middleware: (getDefaultMiddleware) => [
      ...getDefaultMiddleware({ immutableCheck: { warnAfter: 100 } }).concat(apiMiddlewares),
      // Must go before `routerMiddleware` (DO NOT MOVE)
      surfCheckMeteringMiddleware,
      routerMiddleware(history),
      LogRocket.reduxMiddleware(),
    ],
    // The initial backplane reducer is just for the server render, it doesn't need any
    // handlers. It just needs to be present to set the preloaded state from the server side
    reducer: rootReducer(history, extraReducers),
    devTools: process.env.NODE_ENV !== 'production',
  });

  createReducerInjecter(store, (asyncReducers) => rootReducer(history, asyncReducers));

  if (module.hot) {
    module.hot.accept(
      '../reducers',
      // eslint-disable-next-line global-require
      () => store.replaceReducer(require('../reducers').default(history, store.asyncReducers)),
    );
  }

  setupListeners(store.dispatch);

  return store;
}

export default createStore;
